"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarouselDot = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PhotoCarouselDotMixin = require("../../mixins/components/PhotoCarouselDotMixin");
var StyledPhotoCarouselDot = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledPhotoCarouselDot",
  componentId: "c11n-8-107-0__sc-13cmuns-0"
})(["", ""], _PhotoCarouselDotMixin.PhotoCarouselDotMixin);
exports.StyledPhotoCarouselDot = StyledPhotoCarouselDot;